import gettext from "../../../shared/utils/gettext";
import { MeasurementList } from "./MeasurementList";
import React from "react";
import { LayerProps } from "./ObjectInterfaces";
import { useCorrectMeasurements } from "./util";

/* RawLayer Component */
export const RawLayer = ({
  dataset,
  measurements,
  layer,
  selectedMeasurements,
  setNumOfMeasurements,
  setSelectedMeasurements,
}: LayerProps) => {
  const correctMeasurements = useCorrectMeasurements(measurements, setNumOfMeasurements);

  /* JSX */
  return (
    <div className="card-list-item pt-1 border-dash" key={"raw" + dataset.uuid}>
      <i className="icn_dataset" />
      <span>{gettext("Dataset")}</span>
      <MeasurementList
        dataset={dataset}
        measurements={correctMeasurements}
        layer={layer}
        selectedMeasurements={selectedMeasurements}
        setSelectedMeasurements={setSelectedMeasurements}
      />
    </div>
  );
};
